import { Directive, HostListener, ElementRef, OnInit } from "@angular/core";

@Directive({ selector: "[onlyNumbers]" })
export class OnlyNumbersDirective
{
    private el: HTMLInputElement;

    constructor( private elementRef: ElementRef ) {
        this.el = this.elementRef.nativeElement;
    }

    @HostListener("blur", ["$event.target.value"])
    onBlur(value) {
        var patt = new RegExp('^[0-9]+$');
        if((patt.test(value))==false){
            this.elementRef.nativeElement.style.backgroundColor = '#fff0f0';
            this.elementRef.nativeElement.style.borderColor = '#A90329';
            this.el.value = value.replace(/[^0-9]*/gi, "");
        }
        else
        {
            this.elementRef.nativeElement.style.backgroundColor = '#f0fff0';
            this.elementRef.nativeElement.style.borderColor = '#7DC27D';
        }
    }
    /* Cuando presiono tecla */
    @HostListener("keyup", ["$event.target.value"])
    onKeyup(value) {
        var patt = new RegExp('^[0-9]+$');
        if((patt.test(value))==false){
            this.el.value = value.replace(/[^0-9]*/gi, "");
        }
        else
        {
            this.elementRef.nativeElement.style.backgroundColor = '#f0fff0';
            this.elementRef.nativeElement.style.borderColor = '#7DC27D';
        }
    }
    /* Cuando presiono tecla y suelto */
    @HostListener("keydown", ["$event.target.value"])
    onKeydown(value) {
        var patt = new RegExp('^[0-9]+$');
        if((patt.test(value))==false){
            this.elementRef.nativeElement.style.backgroundColor = '#fff0f0';
            this.elementRef.nativeElement.style.borderColor = '#A90329';
            this.el.value = value.replace(/[^0-9]*/gi, "");
        }
        else
        {
            this.elementRef.nativeElement.style.backgroundColor = '#f0fff0';
            this.elementRef.nativeElement.style.borderColor = '#7DC27D';
        }
    }
    /* Cuando tengo presionado consecutivo modif */
    @HostListener("keypress", ["$event.target.value"])
    onKeypress(value) {
        var patt = new RegExp('^[0-9]+$');
        if((patt.test(value))==false){
            this.el.value = value.replace(/[^0-9]*/gi, "");
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/utils/directives/onlyNumbers.directive.ts